import { getDialog } from "../dialogService";
import {
    openProject,
    saveProject,
    saveSilently,
} from "../../three/projectManager";
import * as SceneManager from "../../three/sceneManager";
import { render, resetScene } from "../../three/sceneManager";
import { TransactionManager } from "../../three/TransactionManager";
import {
    cutOutTypes,
    getCutOutPreview,
    recreateCutoutPreview,
    resetCutOutPreview,
} from "../../three/models/cutOuts/cutOutGeneration";
import * as Globals from "../../three/globals";
import { startTour, isActiveTour } from "../../three/tour.js";
import {
    defaultRaehmHeight,
    defaultSchwelleHeight,
    defaultWallElementHeight,
    setActiveInsideDoorHeight,
    setActiveMode,
    setDefaultRoomHeight,
    setFloorConstructionHeight,
    updateSystemParameters,
} from "../../three/globals";
import {
    getRoof,
    createRoof,
    regenerateRoof,
    startManualRoofGeneration,
} from "../../three/models/roofs/roofGeneration";
import { checkForRoofCreation } from "../../three/models/roofs/roof.js";
import {
    generateFloor,
    regenerateFloor,
    setFloorType,
} from "../../three/models/floor/floorGeneration";
import { checkForFloorCreation } from "../../three/models/floor/floor.js";
import {
    applyRoomName,
    hideRoomNameInput,
    setCurrentRoomName,
    toggleRoomLabeling,
} from "../../three/models/rooms/roomGeneration";
import {
    hideFurnitureOptionsContainer,
    loadSelectedFurniture,
    rotateFurniture,
} from "../../three/models/furniture/furniture";
import {
    /* buildingGroup, */
    checkMode,
    clearStates,
    currentDialogObject,
    escapeCommand,
    furnitureGroup,
    /* isDraggingObject, */
    layoutView,
    sceneView,
    setIsDeleteMode,
    setIsDraggingObject,
    toggleModeButtons,
} from "../../three/main";

import {startWallPreview, updateWallSnapAxis} from "../../three/models/walls/wallGeneration";
import {startMeasurementPreview} from "../../three/models/measurements/manualMeasurementGeneration";
import {toggleLayer} from "../../three/utils/layerUtils";
import {reconstructUISettings} from "../../three/utils/dialogUtils";
import {changePillar, startPillarPreview} from "../../three/models/pillar/pillarGeneration";
import {startBeamPreview} from "../../three/models/supportBeam/supportBeamGeneration";
import {showErrorMessage, showErrorMessageWithAlternativeEvent, showMessage, showToast} from "../ui";
import {t} from "../../i18n";
/* import {roofGroupName} from "../../three/constants/nameConstants"; */
import { cursorTarget, setCursor } from "../../three/utils/utils";
import { deleteCursor } from "../../three/constants/cursorConstants";
import {
    exportLayoutView,
    exportSceneView,
} from "../../three/output/outputGeneration";
import { recalculateBuildingParameters } from "../../three/calculators/buildingParameters/parameterCalculator";
import {
    calculateVolumes,
    positions,
} from "../../three/calculators/buildingParameters/volumeCalculator";
import { recalculatePrice } from "../../three/calculators/buildingParameters/costCalculator";
import { exportPartsList } from "../../three/output/componentListExport";
import { checkoutProject } from "../../three/checkout";
import { getProjectSummary } from "../../three/output/projectSummary";
import {
    downloadImageImageDataURLAsPDF,
    downloadImageDirectly,
} from "../../three/utils/fileUtils";
import { forceUserLogin } from "./auth";

let scenesContainer = document.getElementById("scenesContainer");
let templateId = "new";
const body = $("body");

var onLeaveDialogSeen = false;

export function attachGUIEvents() {
    $("#load-project-btn").on("click", () => {
        $("#project-explorer").removeClass("d-none");
    });

    $("#projects-container").on("click", ".scene-select-btn", function () {
        let id = $(this).closest(".template-container").data("template-id");
        openProject(id);
        $("#projectExplorer").addClass("d-none");
    });

    $("#new-project-btn").on("click", function () {
        newProject();
    });

    body.on("click", ".project-remove-btn", function () {
        let container = $(this).closest(".project-item");
        let id = container.data("project-id");
        let name = container.find(".project-name").text();
        if (!(typeof id === "number")) {
            console.error(
                "Projekt kann nicht gelöscht werden. Ungültige Projekt ID.",
            );
            return;
        }

        if (id == templateId) {
            console.error("Projekt kann nicht gelöscht werden. Das aktuell geöffnete Projekt kann nicht gelöscht werden.");
            showErrorMessage(t("project_delete_open"));
            return;
        }

        if (confirm(t("confirm_delete_project", {name: name.trim()}))) {
            $.ajax({
                url: "configurator/scene/" + id,
                method: "delete",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                        "content",
                    ),
                },
                async: false,
                success: function (data) {
                    if (data.success) {
                        showToast(t("project_deleted"));
                        container.remove();
                    } else {
                        showErrorMessage(data.error);
                    }
                },
            });
        }
    });

    $("#undoBtn").on("click", function () {
        if (isActiveTour()) {
            return;
        }
        TransactionManager.undo();
    });

    $("#redoBtn").on("click", function () {
        if (isActiveTour()) {
            return;
        }
        TransactionManager.redo();
    });

    $("#applyRoomName").on("click", function () {
        setCurrentRoomName($("#roomType").val());
    });

    attachCreateComponentEvents();
    attachChangeComponentEvents();
    attachOutputComponentEvents();
    attachLayerEvents();
    attachZoomEvents();
    attachCameraEvents();
    attachFurnitureEvents();

    $("#support-btn").on("click", openSupportPopup);

    body.on("click", ".dialog-close-button", function () {
        let dialog = $(this).parent().parent();

        if (
            dialog.attr("id") === "load-project-draggable-dialog" ||
            dialog.attr("id") === "tutorials-fixed-dialog"
        ) {
            //Projekte laden Dialog ganz schließen. Neue Projekte werden sonst nicht angezeigt.
            dialog.remove();
        } else {
            if (dialog.hasClass("build-element-fixed-dialog")) {
                $(this).closest(".build-element-fixed-dialog").hide();
            } else if (dialog.hasClass("build-element-dialog")) {
                $(this).closest(".build-element-dialog").hide();
            }
        }

        toggleModeButtons();
    });

    $('#roomLabelBtn').on('click', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }

        let mode = checkMode(Globals.modes.roomLabeling);
        //Aufräumen des alten Standes
        clearStates();
        let layer = $("#toggleRoomNameVisibility");
        let layerState = layer
            .closest(".visibility-toggle-wrapper")
            .find(".layer-state");
        let isActive = !layerState.first().hasClass("active");
        if (mode) {
            //deactivate
            setActiveMode(Globals.modes.view);
            toggleRoomLabeling(false);
            if (isActive) {
                $("#toggleRoomNameVisibility").trigger("click");
            }
        } else {
            //activate
            setActiveMode(Globals.modes.roomLabeling);
            if (!isActive) {
                $("#toggleRoomNameVisibility").trigger("click");
            }
            toggleRoomLabeling(true);
        }

        //Toggle
        $(this).toggleClass("active");

        setControlElementImage($(this), checkMode(Globals.modes.roomLabeling));
    });

    attachIconButtonEvents();

    /*DEBUG*/
    if (Globals.isDebug) {
        $("#readScene").on("click", function () {
            SceneManager.readScene();
        });

        $("#clearSceneBtn").on("click", function () {
            resetScene();
        });
    }

    $("#mat-dropdown-button").on("click", function () {
        let volumes = calculateVolumes();
        recalculatePrice(volumes).then((prices) => {
            $("#wall-pos").text(positions.walls);
            $("#wall-price").text(
                prices.wallsPrice.combined.toFixed(2).replace(".", ",") + " €",
            );
            $("#roof-pos").text(positions.roof);
            $("#roof-price").text(
                prices.roofPrice.combined.toFixed(2).replace(".", ",") + " €",
            );
            $("#floor-pos").text(positions.floor);
            $("#floor-price").text(
                prices.floorPrice.combined.toFixed(2).replace(".", ",") + " €",
            );
        });
    });
    handleDropdown("#mat-dropdown-button", "#mat-dropdown-dialog");
    handleDropdown("#sys-params", "#sys-param-dropdown-dialog");

    $("#home-btn, #header-logo-link").on("click", function () {
        if (
            TransactionManager.undoStates.length >= 0 &&
            !confirm("Ungespeicherte Änderungen werden gelöscht. Fortfahren?")
        )
            return;

        window.location.href = "https://hornbach.de";
    });

    $(".alert-save").on("click", function (e) {
        var target, href;
        //Identifying target object
        target = $(e.target);
        //If the target object is a link or is contained in a link we show the confirmation message
        if (
            (e.target.tagName === "A" || target.parents("a").length > 0) &&
            TransactionManager.undoStates.length > 0
        ) {
            //Default behavior is prevented (the link doesn't work)
            e.preventDefault();
            onLeaveDialogSeen = true;
            //var confirmationMessage = 'Wenn Sie die Seite vor dem Speichern verlassen, gehen Ihre Änderungen verloren.';
            var confirmationMessage =
                "Ungespeicherte Änderungen werden gelöscht. Fortfahren?";
            if (window.confirm(confirmationMessage)) {
                //Identify link target
                if (e.target.tagName === "A") {
                    href = target.attr("href");
                } else {
                    href = target.parents("a").first().attr("href");
                }

                //Redirect
                window.location.href = href;
            }
        }
    });

    window.addEventListener("beforeunload", beforeUnloadOperation);
}

export function beforeUnloadOperation(e){
    
        if (TransactionManager.undoStates.length > 0 && !onLeaveDialogSeen) {
            e.preventDefault();
            return "Ungespeicherte Änderungen werden gelöscht. Fortfahren?";
        }
        return undefined;
    
}

export function attachIconButtonEvents() {
    //Wechsel der Images in Icon Buttons zwischen den States (normal, hover, click)
    body.on("mouseenter", ".icon-button", function () {
        let element = $(this);

        if (element.hasClass("fixed-icon-button")) {
            return;
        }

        if (!element.hasClass("active") && !element.hasClass("disabled")) {
            element[0].src = element.data("hover-icon");
        }
    });

    body.on("mouseleave", ".icon-button", function () {
        let element = $(this);

        if (element.hasClass("fixed-icon-button")) {
            return;
        }

        if (!element.hasClass("active")) {
            element[0].src = element.data("regular-icon");
        } else {
            element[0].src = element.data("click-icon");
        }
    });

    body.on("mousedown", ".icon-button", function () {
        let element = $(this);

        if (element.hasClass("fixed-icon-button")) {
            return;
        }

        if (!element.hasClass("disabled")) {
            element[0].src = element.data("click-icon");
        }
    });

    body.on("mouseup", ".icon-button", function () {
        let element = $(this);

        if (element.hasClass("fixed-icon-button")) {
            return;
        }

        if (!element.hasClass("disabled")) {
            element[0].src = element.data("hover-icon");
        } else {
            element[0].src = element.data("regular-icon");
        }
    });
}

function setControlElementImage(control, active) {
    if (active) {
        control[0].src = control.attr("data-src-active");
    } else {
        control[0].src = control.attr("data-src-inactive");
    }
}

function attachCreateComponentEvents() {
    /*Im control-element wird die data-dialog-url gespeichert.
     * Diese wird als URL zum Abrufen des Dialogs verwendet. (web.php)
     * Sie entspricht ebenfalls der ID des daraus resultierenden Dialogs und kann mit dieser dann getogglet werden
     */
    body.on("click", ".control-element", function () {
        if (
            $(this).hasClass("disabled") ||
            $(this).attr("id") === "roomLabelBtn"
        ) {
            return;
        }

        if($(this).attr('id')==='floorBtn' && !checkForFloorCreation()){
            return showErrorMessage(t("floor_no_outer_wall"));
        }

        if($(this).attr('id')==='roofBtn' && !checkForRoofCreation()){
            return showErrorMessageWithAlternativeEvent(t("roof_no_outer_wall"), t("manual_place"), startManualRoofGeneration);
        }

        toggleModeButtons();

        //Toggle
        $(this).toggleClass("active");

        if ($(this).attr("id") === "deleteBtn") {
            setIsDeleteMode($(this).hasClass("active"));
            setCursor(deleteCursor, cursorTarget.both);
        }

        setControlElementImage($(this), $(this).hasClass("active"));

        let dialogId = this.getAttribute("data-dialog-url");
        if (dialogId !== undefined && dialogId !== null) {
            getDialog(scenesContainer, this, dialogId);
            reconstructUISettings(dialogId);
        }
    });

    $("#load-project-btn").on("click", function () {
        let dialogId = this.getAttribute("data-dialog-url");
        if (dialogId !== undefined && dialogId !== null) {
            getDialog(scenesContainer, this, dialogId, null, true);
        }
    });

    $("#tutorial-section-wrapper").on("click", function () {
        let dialogId = this.getAttribute("data-dialog-url");
        if (dialogId !== undefined && dialogId !== null) {
            getDialog(scenesContainer, this, dialogId, null, false);
        }
    });

    $('#innerWallBtn').on('click', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }

        clearStates();
        setActiveMode(Globals.modes.wall, $(this));
        if (checkMode(Globals.modes.wall)) {
            startWallPreview(false);
        }
    });

    $("#outerWallBtn").on("click", function () {
        clearStates();
        setActiveMode(Globals.modes.wall, $(this));
        if (checkMode(Globals.modes.wall)) {
            startWallPreview(true);
        }
    });

    $('#measureBtn').on('click', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }

        clearStates();
        setActiveMode(Globals.modes.measurement, $(this));
        if (checkMode(Globals.modes.measurement)) {
            startMeasurementPreview();
        }
    });

    body.on("click", "#place-manual-roof-btn", function () {
        startManualRoofGeneration();
    });

    body.on("click", "#place-roof-btn", function () {
        createRoof();
    });

    body.on("click", "#place-floor-btn", function () {
        let floorType = $(this)
            .closest(".dialog-body")
            .find("#floor-type-input")
            .val();
        let includeOutside = $(this)
            .closest(".dialog-body")
            .find("#floor-include-outside-input")
            .prop("checked");
        setFloorType(floorType, includeOutside);
        generateFloor();
    });

    body.on("click", "#place-cut-out-btn", function () {
        placeOpening();
    });

    body.on("click", "#place-exterior-door-btn", function () {
        placeExteriorDoor();
    });

    body.on("click", "#place-interior-door-btn", function () {
        placeInteriorDoor();
    });

    body.on("click", "#place-window-btn", function () {
        placeWindow();
    });

    body.on("click", "#place-pillar-btn", function () {
        TransactionManager.startTransaction();
        clearStates();
        setActiveMode(Globals.modes.pillar, $(this));
        if (checkMode(Globals.modes.pillar)) {
            let dialog = $(this).closest(".dialog-body");
            startPillarPreview(
                parseFloat(dialog.find("#pillar-size-input").val()),
                defaultWallElementHeight +
                    defaultSchwelleHeight +
                    defaultRaehmHeight,
            );
        }
    });

    body.on("click", "#place-beam-btn", function () {
        TransactionManager.startTransaction();
        clearStates();
        setActiveMode(Globals.modes.beam, $(this));
        if (checkMode(Globals.modes.beam)) {
            let dialog = $(this).closest(".dialog-body");
            startBeamPreview(
                parseFloat(dialog.find("#beam-size-input").val()),
                dialog
                    .find("#beam-force-even-pillar-amount-input")
                    .prop("checked"),
            );
        }
    });

    $("#roomSplitBtn").on("click", () => {
        // startRoomLinePreview();
    });
}

export function placeOpening() {
    TransactionManager.startTransaction();
    resetCutOutPreview();
    getCutOutPreview(
        cutOutTypes.cutOut,
        $("#place-cut-out-btn")
            .closest(".dialog-body")
            .find("#cut-out-width-input")
            .val(),
        null,
    );
}

export function placeExteriorDoor() {
    TransactionManager.startTransaction();
    resetCutOutPreview();
    let dialog = $("#place-exterior-door-btn").closest(".dialog-body");
    getCutOutPreview(
        cutOutTypes.exteriorDoor,
        dialog.find("#exterior-door-width-input").val(),
        Globals.defaultWallElementHeight,
    );
}

export function placeInteriorDoor() {
    TransactionManager.startTransaction();
    resetCutOutPreview();
    let dialog = $("#place-interior-door-btn").closest(".dialog-body");
    getCutOutPreview(
        cutOutTypes.interiorDoor,
        dialog.find("#interior-door-width-input").val(),
        dialog.find("#interior-door-height-input").val(),
    );
}

export function placeWindow() {
    TransactionManager.startTransaction();
    resetCutOutPreview();
    let dialog = $("#place-window-btn").closest(".dialog-body");
    getCutOutPreview(
        cutOutTypes.window,
        dialog.find("#window-width-input").val(),
        dialog.find("#window-height-input").val(),
    );
}

function attachChangeComponentEvents() {
    body.on(
        "click",
        ".dialog-place-button, .dialog-change-button",
        function () {
            let fixedDialog = $(this).closest(".build-element-fixed-dialog");
            let draggaleDialog = $(this).closest(".build-element-dialog");

            if (fixedDialog.length > 0) {
                fixedDialog.hide();
            }

            if (draggaleDialog.length > 0) {
                draggaleDialog.hide();
            }
        },
    );

    //Neugenerierung der Preview bei geänderten Einstellungen

    body.on("click", "#change-cut-out-btn", function () {
        let dialog = $(this).closest(".build-element-dialog");
        let width = dialog.find("#cut-out-width-range-input").val();
        let height = dialog.find("#cut-out-height-input").val();
        resetCutOutPreview();
        changeCutout(
            currentDialogObject.object,
            cutOutTypes.cutOut,
            width,
            height,
        );
    });

    body.on("click", "#change-exterior-door-btn", function () {
        let dialog = $(this).closest(".build-element-dialog");
        let width = dialog.find("#exterior-door-width-range-input").val();
        let height = dialog.find("#exterior-door-height-input").val();
        resetCutOutPreview();
        changeCutout(
            currentDialogObject.object,
            cutOutTypes.exteriorDoor,
            width,
            height,
        );
    });

    body.on("click", "#change-interior-door-btn", function () {
        let dialog = $(this).closest(".build-element-dialog");
        let width = dialog.find("#interior-door-width-input").val();
        let height = dialog.find("#interior-door-height-input").val();
        resetCutOutPreview();
        changeCutout(
            currentDialogObject.object,
            cutOutTypes.interiorDoor,
            width,
            height,
        );
    });

    body.on("click", "#change-window-btn", function () {
        let dialog = $(this).closest(".build-element-dialog");
        let width = dialog.find("#window-width-range-input").val();
        let height = dialog.find("#window-height-range-input").val();
        resetCutOutPreview();
        changeCutout(
            currentDialogObject.object,
            cutOutTypes.window,
            width,
            height,
        );
    });

    body.on("keyup", "#window-height-input", function () {
        let dialogBody = $(this).closest(".dialog-body");
        let height = $(this).val();
        let bottomOffset = Globals.defaultWallElementHeight - height;
        dialogBody
            .find("#window-bruestung-height-input")
            .val(bottomOffset.toFixed(3));
    });

    body.on("input", "#window-height-range-input", function () {
        let dialogBody = $(this).closest(".dialog-body");
        let height = $(this).val();
        let bottomOffset = Globals.defaultWallElementHeight - height;
        dialogBody
            .find("#window-bruestung-height-input")
            .val(bottomOffset.toFixed(3));
    });

    body.on("input", "#window-bruestung-height-input", function () {
        let dialogBody = $(this).closest(".dialog-body");
        let bottomOffset = $(this).val();
        let height = Globals.defaultWallElementHeight - bottomOffset;
        dialogBody
            .find("#window-height-input")
            .val(height.toFixed(3))
            .trigger("change");
        dialogBody
            .find("#window-height-range-input")
            .val(height.toFixed(3))
            .trigger("change");
    });

    body.on("click", "#change-roof-btn", function () {
        TransactionManager.startTransaction();
        let dialog = $(this).closest(".build-element-dialog");
        let roof = getRoof();
        let orientation = roof.userData.roof.orientation.valueOf();
        let roofValues = {
            roofType: parseFloat(
                $('input[name="roof-type-input"]:checked').val(),
            ),
            orientation: parseInt(
                dialog.find("#roof-orientation-select").val(),
            ),
            overhang: parseFloat(dialog.find("#roof-overhang-input").val()),
            addAttika: dialog.find("#roof-add-attika-input").prop("checked"),
            attikaHeight: parseFloat(
                dialog.find("#roof-add-attika-height-input").val(),
            ),
        };
        regenerateRoof(roofValues);
        if (orientation !== roofValues.orientation) {
            regenerateFloor();
        }
        TransactionManager.stopTransaction();
    });

    body.on("click", "#change-floor-btn", function () {
        TransactionManager.startTransaction();
        let dialog = $(this).closest(".build-element-dialog");
        let floorType = dialog.find("#floor-type-input").val();
        let includeOutside = dialog
            .find("#floor-include-outside-input")
            .prop("checked");
        setFloorType(floorType, includeOutside);
        regenerateFloor();
        TransactionManager.stopTransaction();
    });

    body.on("click", "#change-pillar-btn", function () {
        let dialog = $(this).closest(".build-element-dialog");
        let size = parseFloat(dialog.find("#pillar-size-input").val());
        changePillar(currentDialogObject.object, size);
    });

    body.on('click', '#change-beam-btn', function () {
        showMessage(t("beam_cannot_edit"), "Hinweis");

        //TODO: Mit Anpassbarkeit von automatischen Unterzügen wieder aktivieren
        /*let dialog = $(this).closest('.build-element-dialog');
        let width = parseFloat(dialog.find('#beam-size-input').val());
        changeCutout(currentDialogObject.object, width);*/
    });
}

function changeCutout(controlObject, type, width, height) {
    TransactionManager.startTransaction();
    recreateCutoutPreview(type, controlObject, true);
    getCutOutPreview(type, width, height);
}

function attachFurnitureEvents() {
    //Drag&Drop von Einrichtung>
    body.on(
        "dragstart",
        "#furniture-elements-container>.furniture-element-img",
        function () {
            return false; //Drag-and-drop des Bildes eines Möbelstücks verhindern
        },
    );

    body.on("mousedown", ".furniture-element", function () {
        TransactionManager.startTransaction();
        let name = $(this).attr("data-name");
        let model = Globals.modelsFolder + $(this).attr("data-model-location");
        let scaleFactor = parseFloat($(this).attr("data-scale-factor"));
        let yOffset = parseFloat($(this).attr("data-y-offset"));
        clearStates();
        Globals.setActiveMode(Globals.modes.furniture);
        setIsDraggingObject(true);
        hideFurnitureOptionsContainer();

        let material = $(this).attr("data-materials-location");
        if (material !== "") {
            material = Globals.modelsFolder + material;
        }

        loadSelectedFurniture(
            furnitureGroup,
            material,
            model,
            name,
            scaleFactor,
            yOffset,
        ).then(() => console.log("Furniture loaded"));
        $("#furniture-fixed-dialog").remove();
    });
    //<Drag&Drop von Einrichtung>

    $("#furniture-rotation-map").on(
        "click",
        ".furniture-rotation-area",
        function () {
            let rotation = $(this).data("rotation");
            rotateFurniture(rotation);
        },
    );
}

function attachLayerEvents() {
    $(".visibility-toggle-btn").on("click", function () {
        let layerState = $(this)
            .closest(".visibility-toggle-wrapper")
            .find(".layer-state");
        layerState.toggleClass("active");
        let isActive = !layerState.first().hasClass("active");
        let layerCamera = $(this).data("layer-camera");
        let layerString = $(this).data("layer").toString();
        let layers = layerString.split(",");

        for (let i = 0; i < layers.length; i++) {
            let layer = layers[i];
            if (layerCamera === "both") {
                toggleLayer(SceneManager.sceneCamera, layer);
                toggleLayer(SceneManager.layoutCamera, layer);
                if (layer == Globals.layers.roomNames) {
                    toggleRoomLabeling(isActive);
                    let alreadyRoomMode = checkMode(Globals.modes.roomLabeling); //already enabled in $('#roomLabelBtn').on('click'
                    let mode = isActive
                        ? Globals.modes.roomLabeling
                        : Globals.modes.view;
                    setActiveMode(mode);
                    if (isActive) {
                        if (!alreadyRoomMode) {
                            setControlElementImage($("#roomLabelBtn"), true);
                            $("#roomLabelBtn").toggleClass("active");
                        }
                    } else {
                        if (alreadyRoomMode) {
                            setControlElementImage($("#roomLabelBtn"), false);
                            $("#roomLabelBtn").toggleClass("active");
                        }
                    }
                }
            } else if (layerCamera === "scene") {
                toggleLayer(SceneManager.sceneCamera, layer);
            } else if (layerCamera === "layout") {
                toggleLayer(SceneManager.layoutCamera, layer);
            }
        }
    });
}

function attachCameraEvents() {
    const cameraButtons = $("#camera-rotation-map-wrapper").children();

    $(".enableCam").on("click", function () {
        SceneManager.activateCameraByName($(this).attr("id"));
        cameraButtons.removeClass("active");
        $(this).addClass("active");
        cameraButtons.trigger("mouseout");
    });
}

const rotations = [0, 90, 180, 270];
var rotationIndex = 0;

function attachZoomEvents() {
    layoutView.onwheel = function (e) {
        if (e.ctrlKey && checkMode(Globals.modes.furniture)) {
            ++rotationIndex;
            if (rotationIndex == rotations.length) {
                rotationIndex = 0;
            }
            rotateFurniture(rotations[rotationIndex]);
            e.preventDefault();
            e.stopPropagation();
            render();
            return false;
        }
        render();
    };

    sceneView.onwheel = () => {
        render();
    };
}

function handleDropdown(dropdownBtnId, dropdownDialogId) {
    let dropdownBtn = $(dropdownBtnId);
    dropdownBtn.on("click", function (e) {
        let activeDropDowns = $(".dropdown-dialog").not(dropdownDialogId);
        if (activeDropDowns.hasClass("active")) {
            activeDropDowns.removeClass("active");
        }

        let dropdown = $(dropdownDialogId);
        dropdown.toggleClass("active");

        let parent = dropdownBtn.parent();
        let parentOffset = dropdownBtn.parent().offset();

        dropdown.css({
            top: parentOffset.top + parent.outerHeight() + "px",
            left:
                parentOffset.left -
                (dropdown.outerWidth() - parent.outerWidth()) +
                "px",
        });
        e.stopImmediatePropagation();
    });
}

$(document).on("click", function () {
    let activeDropDowns = $(".dropdown-dialog");
    if (activeDropDowns.hasClass("active")) {
        activeDropDowns.removeClass("active");
    }
});
$("#sys-params").on("click", function () {
    let roof = getRoof();
    let thickness = roof ? roof.userData.roof.thickness : 0;
    $("#roof-value").text(thickness + " m");
});
$("document").ready(function () {
    setActiveInsideDoorHeight(innerDoorHeight);
    setDefaultRoomHeight(roomHeight);
    setFloorConstructionHeight(floorConstruction);
    updateSystemParameters();
});

$(document).on("mouseup", function (e) {
    let dialogs = $(
        ".build-element-fixed-dialog:visible, .build-element-dialog:not(.help-dialog, .tutorial-dialog):visible",
    );
    let removableDialogs = $(".tutorial-dialog, .help-dialog");

    if (dialogs.length === 0 && removableDialogs.length === 0) return;

    if (
        dialogs.has(e.target).length === 0 &&
        dialogs.length > 0 &&
        removableDialogs.length === 0
    ) {
        dialogs.each((index, dialog) => {
            $(document).one("click", function (e) {
                let offset = $(dialog).offset();
                if (
                    !(
                        e.pageY > offset.top &&
                        e.pageX > offset.left &&
                        e.pageY < offset.top + $(dialog).height() &&
                        e.pageX < offset.left + $(dialog).width()
                    )
                ) {
                    $(dialog).hide();
                    toggleModeButtons();
                }
            });
        });
    }
    if (
        removableDialogs.has(e.target).length === 0 &&
        removableDialogs.length > 0
    ) {
        removableDialogs.each((index, dialog) => {
            $(document).one("click", function (e) {
                if ($(dialog) !== $(e.target)) {
                    $(dialog).remove();
                }
            });
        });
    }
});

$(body).one("click", function () {
    $(window).on("beforeunload", function (e) {
        if (!Globals.isDebug) {
            return (e.returnValue = t("unsaved_changes"));
        }
    });
});

$("#cancel-room-input").on("click", function () {
    hideRoomNameInput();
});

$("#apply-room-input").on("click", function () {
    applyRoomName($("#label-room-input").val());
});

/*Ausgabe / Checkout*/
let screenshotInProgress = false;
let checkoutInProgress = false;
let projectSummaryInProgress = false;

function attachOutputComponentEvents() {
    //Setzen eine Variable, um sicherzustellen, dass nur ein Prozess gleichzeitig läuft. Die Callbacks setzten den Wert anschließend wieder zurück;

    //Export des aktuellen Grundrisses als Bild
    $('#layoutOutputBtn').on('click', function (e) {
        if ($(this).hasClass('disabled')) {
            return;
        }
        downloadScreenshot(e, false)
    });

    //Export der aktuellen 3D-Ansicht als Bild
    $('#screenshotBtn').on('click', function (e) {
        if ($(this).hasClass('disabled')) {
            return;
        }
        downloadScreenshot(e, true)
    });

    $('#materialListBtn').on('click', function (e) {
        if ($(this).hasClass('disabled')) {
            return;
        }
        recalculateBuildingParameters();
        exportPartsList(true);
        escapeCommand();
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.cancelBubble = true;
    });

    /*Projektmappe*/
    $('#projectSummaryBtn').on('click', function (e) {
        if ($(this).hasClass('disabled')) {
            return;
        }
        if (projectSummaryInProgress) {
            return showErrorMessage(t("summary_in_progress"));
        }
        try {
            setProjectSummaryInProcess(true);
            e.stopPropagation();
            e.stopImmediatePropagation();
            e.cancelBubble = true;
            escapeCommand();
            forceUserLogin(
                () => {
                    saveProject(
                        () => {
                            getProjectSummary(
                                true,
                                () => {
                                    setProjectSummaryInProcess(false);
                                },
                                () => {
                                    setProjectSummaryInProcess(false);
                                },
                            );
                        },
                        () => {
                            setProjectSummaryInProcess(false);
                        },
                    );
                },
                () => {
                    setProjectSummaryInProcess(false);
                },
            );
        } catch {
            setProjectSummaryInProcess(false);
        }
    });

    /*Checkout*/
    $("#shopping-cart-btn").on("click", function () {
        if (checkoutInProgress) {
            return showErrorMessage(t("checkout_in_progress"));
        }

        setCheckoutInProgress(true);

        var onFailure = () => {
            setCheckoutInProgress(false);
        };

        forceUserLogin(() => {
            saveProject(() => {
                checkoutProject(onFailure, onFailure);
            }, onFailure);
        }, onFailure);
    });

    /*Speichern*/
    $("#save-project-btn").on("click", () => {
        forceUserLogin(() => {
            saveProject();
        });
    });
    

    $("#restart-demo-btn").on("click", () => {
        if (isActiveTour()) {
            console.log("tour is still active, bail");
            return;
        }

        if (TransactionManager.undoStates.length > 0 && confirm(t("unsaved_changes"))) {
            newProject();
            startTour();
            return;
        }

        if (TransactionManager.undoStates.length == 0) startTour();
    });
}

function downloadScreenshot(e, isSceneView) {
    if (screenshotInProgress) {
        return showErrorMessage(t("image_export_in_progress"));
    }
    try {
        setScreenshotInProcess(true);
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.cancelBubble = true;
        escapeCommand();
        forceUserLogin(
            () => {
                let image = isSceneView
                    ? exportSceneView(true)
                    : exportLayoutView();
                downloadImageDirectly(
                    image,
                    isSceneView ? "3D-Ansicht.pdf" : "Grundriss-Ansicht.pdf",
                );
                setScreenshotInProcess(false);
            },
            () => {
                setScreenshotInProcess(false);
            },
        );
    } catch {
        setScreenshotInProcess(false);
    }
}

function setScreenshotInProcess(val) {
    screenshotInProgress = val;
    toggleModeButtons();
    return screenshotInProgress;
}

function setCheckoutInProgress(val) {
    checkoutInProgress = val;
    toggleModeButtons();
    return checkoutInProgress;
}

function setProjectSummaryInProcess(val) {
    projectSummaryInProgress = val;
    toggleModeButtons();
    return projectSummaryInProgress;
}

export function newProject() {
    if (!Globals.isDebug) {
        if (TransactionManager.undoStates.length >= 0 && !confirm(t("unsaved_changes"))) {
            return;
        }
    }

    if (window.location.toString().includes("template_id=new")) {
        resetScene();
        clearStates();
        updateWallSnapAxis();
        recalculateBuildingParameters();
    } else {
        window.location = "/configurator?template_id=new";
    }

    templateId = "new";
}

function openSupportPopup(event) {
    event.preventDefault();
    const url = event.currentTarget.dataset.url;
    const title = event.currentTarget.dataset.title;

    // Create popup container
    const popup = document.createElement("div");
    popup.className = "support-popup-overlay";
    popup.innerHTML = `
        <div class="support-popup-content">
            <div class="build-element-dialog" style="width: 100%;height: 100%;max-height: inherit;">
                <div class="dialog-header-bar">
                    <div class="dialog-close-button">x</div>
                </div>
                <div class="dialog-title-bar">${title}</div>
                <div class="dialog-body" style="flex-grow:1;background-color:#1e1e1e;">
                    <div class="dialog-lower-body">
                        <iframe src="${url}" frameborder="0"></iframe>
                    </div>
                </div>
            </div>

        </div>
    `;

    // Add popup to body
    document.body.appendChild(popup);

    // Close popup handler
    popup
        .querySelector(".dialog-close-button")
        .addEventListener("click", () => {
            popup.remove();
        });

    // Close on overlay click
    popup.addEventListener("click", (e) => {
        if (e.target === popup) {
            popup.remove();
        }
    });
}

// Function to close support popup
window.closePopup = function () {
    const popup = document.querySelector(".support-popup-overlay");
    if (popup) {
        popup.remove();
    }
};
